import { Injectable } from "@angular/core";
import { LocalStorageType } from './local-storage-type.enum';
import { LocalMemoryCache } from "./local-memory-cache.model";
import { LocalMemoryCacheService } from "./local-memory-cache.service";

@Injectable({
  providedIn: 'root'
})
export class LocalDataCacheService {
  localStorageCache: Storage | LocalMemoryCache;
  sessionStorageCache: Storage | LocalMemoryCache;

  constructor(private localMemoryCache: LocalMemoryCacheService) {
    try {
      this.localStorageCache = localStorage
    }
    catch{
      this.localStorageCache = localMemoryCache.localStorage
    };

    try {
      this.sessionStorageCache = sessionStorage
    } catch{
      this.sessionStorageCache = localMemoryCache.sessionStorage
    }

  }

  private getStorage(storageType: LocalStorageType): Storage | LocalMemoryCache {
    if (storageType === LocalStorageType.LocalStorage)
      return this.localStorageCache;
    else
      return this.sessionStorageCache;
  }

  public getLocalStorage(): Storage | LocalMemoryCache {
    return this.localStorageCache;
  }

  public getSessionStorage(): Storage | LocalMemoryCache {
    return this.sessionStorageCache;
  }
}
